import { UIHeading1, UIHeading2, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ContactsModal.css';
import { Logo } from '../Logo';

interface IContactsModalProps {
  phone: string;
  logo: string;
  name: string;
}

export const ContactsModal: React.FC<IContactsModalProps> = ({ phone, logo, name }) => {
  return (
    <div className={styles['container']}>
      <UIHeading2>Контакты строительной компании</UIHeading2>
      <div className={styles['phone']}>
        <UIHeading1>{phone}</UIHeading1>
      </div>
      <div className={styles['footer']}>
        <Logo img={logo} size={40} />
        <div className={styles['company']}>
          <div>Строительная компания</div>
          <UIHeading4>{name}</UIHeading4>
        </div>
      </div>
    </div>
  );
};
